import React from 'react';
import {
	IonSelect,
	IonSelectOption,
	SelectChangeEventDetail,
} from '@ionic/react';
import { FilterButtonContainer } from './filterButtonStyles';
import { IonSelectCustomEvent } from '@ionic/core';

const FilterButton: React.FC<{
	onChangeHandler: (
		e: IonSelectCustomEvent<SelectChangeEventDetail<any>>,
	) => {};
}> = ({ onChangeHandler }) => {
	return (
		<FilterButtonContainer>
			{/* <SortByLabel>Sort:</SortByLabel> */}
			{/* TODO: Loop over activities or topics and produce the select options with an onchange handler */}
			<IonSelect
				interface="action-sheet"
				value={'all'}
				onIonChange={onChangeHandler}>
				<IonSelectOption value="all">Show All</IonSelectOption>
				<IonSelectOption value="recommended">
					Recommended
				</IonSelectOption>
				<IonSelectOption value="accessibility">
					Easy Access
				</IonSelectOption>
				{/*<IonSelectOption value="topic">*/}
				{/*	Topic or Activity?*/}
				{/*</IonSelectOption>*/}
				{/*<IonSelectOption value="activity">Activity</IonSelectOption>*/}
			</IonSelect>
		</FilterButtonContainer>
	);
};

export default FilterButton;
